import { AppThunkAction } from "..";
import { KnownAction, SHOW_UPDATING_ADDITIONAL_INFO_LOADER } from "./types";

export const actionCreators = {
    updatingAdditionalInfoLoaderStatus:
        (status: boolean): AppThunkAction<KnownAction> =>
        (dispatch, getState) => {
            dispatch({ type: SHOW_UPDATING_ADDITIONAL_INFO_LOADER, isUpdatingAdditionalInfo: status });
        },
};
